import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL_LOGIN } from "../constants";

const initialState = {
  user: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const SignUpUser = createAsyncThunk(
  "user/SignUpUser",
  async (user, thunkAPI) => {
    if (
      user.nama_lengkap.trim() === "" ||
      user.asal_instansi.trim() === "" ||
      user.grup_peserta.trim() === "" ||
      user.jenis_kelamin.trim() === ""
    ) {
      const message = "Silahkan lengkapi data anda !";
      return thunkAPI.rejectWithValue(message);
    } else if (user.token.trim() === "") {
      const message = "Silahkan masukkan token !";
      return thunkAPI.rejectWithValue(message);
    } else {
      try {
        const response = await axios.post(API_URL_LOGIN + "/login/signup", {
          nama_lengkap: user.nama_lengkap,
          asal_instansi: user.asal_instansi,
          grup_peserta: user.grup_peserta,
          jenis_kelamin: user.jenis_kelamin,
          token: user.token,
        });
        return response.data;
      } catch (error) {
        if (error.response) {
          const message = error.response.data.msg;
          return thunkAPI.rejectWithValue(message);
        }
      }
    }
  }
);

export const authSlice = createSlice({
  name: "authSignUp",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(SignUpUser.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(SignUpUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.user = action.payload;
    });

    builder.addCase(SignUpUser.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    });
  },
});

export const { reset } = authSlice.actions;

export default authSlice.reducer;
